export default {
  revenue: 'Value',
  'value': 'Value',
  appointments: 'Appointments',
  'new-clients': 'New clients',
  title: 'Appointment List',
  'invite-clients': 'Invite clients',
}
